export default __webpack_public_path__ + "static/media/digita-logo-white.d7a8b42f.svg";